// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1rr38","info":"Note_info__UVTTF","note":"Note_note__3VXUW","actions":"Note_actions__1fYA5"};